import axios from "axios";

const auth_axios = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  timeout: 30000,
});

const custom_axios = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  timeout: 30000,
});

custom_axios.interceptors.request.use(function (request) {
  request.headers.Authorization = `Basic ${request}`;
  return request;
});

/***********************************************************************************/
/***********************************************************************************/

/**
 * authenticateUser, Function used to authenticate the user using username
 * and password.
 *
 * @param {string} username  username of the user attempting to authenticate
 * @param {string} password  password of the user attempting to authenticate
 * @param {string} path      request url path excluding the baseURL
 *
 * @returns array that contains the response data or error. [response, error]
 */
export const authenticateUser = async (username, password, path = "/auth") => {
  const data = { UserName: username, Password: password };

  try {
    const response = await auth_axios.post(path, data);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

/**
 * getUsers, is expected to obtain all the users from the DB.
 *
 * @param {string} path the request url path excluding the baseURL
 *
 * @returns array that contains the response data or error. [response, error]
 */
export const getUsers = async (path) => {
  try {
    const response = await custom_axios.get(path);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

/**
 * getUsersByRole, is expected to obtain all the users from the DB of a specific 'ROLE'
 *
 * @param {string} path the request url path excluding the baseURL
 *
 * @returns array that contains the response data or error. [response, error]
 */
export const getUsersByRole = async (role, path = "/users") => {
  try {
    const response = await custom_axios.get(`${path}/${role}`);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

export const getUsersByUserName = async (username, path = "/users/byusername") => {
  try {
    const response = await custom_axios.get(`${path}/${username}`);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

/**
 *
 * @param {string} id
 * @param {string} path the request url path excluding the baseURL
 *
 * @returns array that contains the response data or error. [response, error]
 */
export const createUser = async (data, path = "/user") => {
  try {
    const response = await custom_axios.post(path, data);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

/**
 *
 * @param {string} id
 * @param {string} path the request url path excluding the baseURL
 *
 * @returns array that contains the response data or error. [response, error]
 */
export const updateUser = async (id, data, path = "/user") => {
  try {
    const response = await custom_axios.post(`${path}/${id}`, data);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

/**
 *
 * @param {*} id
 * @param {string} path the request url path excluding the baseURL
 *
 * @returns array that contains the response data or error. [response, error]
 */
export const deleteUser = async (id, path = "/user") => {
  try {
    const response = await custom_axios.delete(`${path}/${id}`);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

/**
 *
 * @param {*} username
 * @param {*} password
 * @param {string} path the request url path excluding the baseURL
 *
 * @returns array that contains the response data or error. [response, error]
 */
export const getWorklist = async (path) => {
  try {
    const response = await custom_axios.get(path);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

export const getPatientBySessionId = async (id, path = "/patient/session") => {
  try {
    const response = await custom_axios.get(`${path}/${id}`);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

export const getPatientByIdNum = async (id, path = "/patient/id") => {
  try {
    const response = await custom_axios.get(`${path}/${id}`);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};


//-------------------Modality ------------------- //
export const writeModalityFile = async (data, path = "/write-to-modality") => {
  try {
    const response = await custom_axios.post(path, data);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

//-------------------spellchecker ------------------- //
export const spellchecker = async (data, path = "/spellchecker") => {
  try {
    const response = await custom_axios.post(path, data);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};


// ------------------ Schedule ------------------ //

export const getSchedulerProcedures = async (
  id,
  path = "/scheduler-procedures"
) => {
  try {
    const response = await custom_axios.get(`${path}/${id}`);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

export const updateSchedulerProcedure = async (
  data,
  path = "/scheduler-procedure"
) => {
  try {
    const response = await custom_axios.post(path, data);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

export const deleteSchedulerProcedure = async (
  id,
  path = "/scheduler-procedures"
) => {
  try {
    const response = await custom_axios.delete(`${path}/${id}`);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};
//

export const editPatient = async (id, data, path = "/patient/id") => {
  try {
    const response = await custom_axios.post(`${path}/${id}`, data);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

/**
 *
 * @param {*} data
 * @param {string} path the request url path excluding the baseURL
 *
 * @returns array that contains the response data or error. [response, error]
 */
export const createStudy = async (data, path = "/study") => {
  try {
    const response = await custom_axios.post(path, data);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

export const updateStudy = async (data, path = "/study") => {
  console.log("updatedStudyWithAudio",data);
  try {
    const response = await custom_axios.post(
      `${path}/${data.Accession}`,
      data
    );
    return [response.data, null];
  } catch (error) {
    console.log("errorFromFunc",error);
    return [null, error];
  }
};

export const updateStudyWithAccession = async (data,Accession, path = "/study") => {
  console.log("updatedStudyWithAudio",data);
  try {
    const response = await custom_axios.post(
      `${path}/${Accession}`,
      data
    );
    return [response.data, null];
  } catch (error) {
    console.log("errorFromFunc",error);
    return [null, error];
  }
};

export const getPreviouseStudies = async (id, path = "/study/history") => {
  try {
    const response = await custom_axios.get(`${path}/${id}` );
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

export const getStudiesByAccession = async (id, path = "/studybyid") => {
  try {
    const response = await custom_axios.get(`${path}/${id}` );
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

export const getAllergies = async (path = "/allergies") => {
  try {
    const response = await custom_axios.get(path);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

export const getStudyProcedure = async (id,path = "/study") => {
  try {
    console.log("getStudyProcedure ID: ",id)
    const response = await custom_axios.get(`${path}/${id}`);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

export const getBranches = async (path = "/branches") => {
  try {
    const response = await custom_axios.get(path);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

export const getPostalCodes = async (path = "/postalcode") => {
  try {
    const response = await custom_axios.get(path);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

export const createBranch = async (data, path = "/branch") => {
  try {
    const response = await custom_axios.post(path, data);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

export const updateBranch = async (data, path = "/branch") => {
  try {
    const response = await custom_axios.patch(`${path}/${data.Id}`, data);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

/**
 *
 * @param {*} id
 * @param {string} path the request url path excluding the baseURL
 *
 * @returns array that contains the response data or error. [response, error]
 */
export const deleteBranch = async (id, path = "/branch") => {
  try {
    const response = await custom_axios.delete(`${path}/${id}`);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

export const getProcedures = async (path = "/procedures") => {
  try {
    const response = await custom_axios.get(path);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

export const createProcedure = async (data, path = "/procedure") => {
  try {
    const response = await custom_axios.post(path, data);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

export const getTemplates = async (path = "/templates") => {
  try {
    const response = await custom_axios.get(path);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

export const createTemplate = async (data, path = "/template") => {
  try {
    const response = await custom_axios.post(path, data);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

export const deleteTemplate = async (id, path = "/template") => {
  try {
    const response = await custom_axios.delete(`${path}/${id}`);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

/**
 *
 * @param {*} id
 * @param {string} path the request url path excluding the baseURL
 *
 * @returns array that contains the response data or error. [response, error]
 */
export const deleteProcedure = async (id, path = "/procedure") => {
  try {
    const response = await custom_axios.delete(`${path}/${id}`);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};

export const updateProcedure = async (data, path = "/procedure") => {
  try {
    let id = typeof(data.id) != "undefined"? data.id : data.Id
    console.log("data.id",id);
    const response = await custom_axios.post(`${path}/${id}`, data);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};


export const writeProcedurePipedData = async ( updatedStudy,patientData, path = '/write-piped-data') => {
  try {
    const data = {
      patientData:patientData,
      studydata:updatedStudy
    }
    const response = await custom_axios.post(path,data);
    return [response.data,null]
  } catch (error) {
    return [null,error]
  }

}

export const resendBilling = async ( Accession,updatedStudy,patientData, path = '/write-piped-data') => {
  try {
    const data = {
      patientData:patientData,
      studydata:updatedStudy
    }
    const response =await custom_axios.post(`${path}/${Accession}`, data);
    return [response.data,null]
  } catch (error) {
    return [null,error]
  }

}

//bill

export const getbillingInfo = async (path) => {
  try {
    const response = await custom_axios.get(path);
    return [response.data, null];
  } catch (error) {
    return [null, error];
  }
};
